  
document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.js-track');
  // 画像１セット分を複製して連結
  track.innerHTML += track.innerHTML;

  let position = 0;
  const speed = 0.5; // 0.5px／フレームずつ動かす例

  function loop() {
    position += speed;
    const fullWidth = track.scrollWidth / 2; 
    if (position >= fullWidth) position = 0;
    track.style.transform = `translateX(${-position}px)`;
    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);
});

// アンカーリンク
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute("href"));
    if (target) {
      const isMobile = window.innerWidth <= 748;
      const yOffset = isMobile ? -40 : -100; 
      const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  });
});
